import { render, staticRenderFns } from "./LOBCosts.vue?vue&type=template&id=e3c5e670&scoped=true&"
import script from "./LOBCosts.vue?vue&type=script&lang=js&"
export * from "./LOBCosts.vue?vue&type=script&lang=js&"
import style0 from "./LOBCosts.vue?vue&type=style&index=0&id=e3c5e670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c5e670",
  null
  
)

export default component.exports